/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ProgramEnvironmentalBenefitsTargetValueViewer} from "./ProgramEnvironmentalBenefitsTargetValueViewer";
import autobind from "autobind-decorator";

export class ModelUpliftEnvironmentalBenefitsTargetValueViewer extends ProgramEnvironmentalBenefitsTargetValueViewer {
	//override
	@autobind
	getSelectedBenefitId() {
		const {Data} = this.props;
		return Data?.SampleEvent?.environmentalBenefitId || -1;
	}
}